import { ArticleListService } from './../../services/article-list.service';
import { ArtigosPaginados } from './../../classes/artigos-paginados';
import { Component, Input, HostListener, ElementRef, ViewChild  } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-page-header',
  templateUrl: './page-header.component.html',
  styleUrls: ['./page-header.component.css'],
  standalone: false,
})
export class PageHeaderComponent {
  constructor(
    private articleListService: ArticleListService,
    private router: Router,
  ) {}

  search;
  paginatedArticles: ArtigosPaginados;
  notFound = false;
  characters = 0;
  isDropdownOpen = false;
  highlightedIndex = -1;

  @Input() pageHeader: { title: string; style: string };

  searchValue(text) {
    this.articleListService
      .getArticleList(text, 0, 0) // Passando a página e o limite como 0, não é feito a paginação
      .subscribe((res) => {
        this.paginatedArticles = res;
        this.isDropdownOpen = true;
        if (res.artigos.length == 0) {
          this.notFound = true;
        } else {
          this.notFound = false;
        }
      });
  }

  valuechange(newValue) {
    this.characters = newValue.length;
    if (newValue.length > 2) {
      this.searchValue(newValue);
    }
  }

  @ViewChild('searchWrapper') searchWrapper: ElementRef;

  // Se clicarem fora da busca, vamos fechar os resultados
  @HostListener('document:click', ['$event'])
  clickOutside(event: MouseEvent) {
    if (
      this.searchWrapper &&
      !this.searchWrapper.nativeElement.contains(event.target)
    ) {
      this.isDropdownOpen = false;
    }
  }

  onFocusSearch() {
    if (this.search && this.search.length > 2 && this.paginatedArticles) {
      this.isDropdownOpen = true;
    }
  }

  redirectTag(tag) {
    if (tag.length != 0) {
      this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
        this.router.navigate(['/tag'], { queryParams: { s: encodeURI(tag) } });
      });
    }
  }

  redirectArticle(article, category) {
    this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
      this.router.navigate(['category/' + category + '/article/' + article]);
    });
  }

  // Navegação na busca pelo teclado
  onKeyDown(event: KeyboardEvent) {
    if (!this.paginatedArticles?.artigos?.length) {
      return;
    }

    const maxIndex = Math.min(this.paginatedArticles.artigos.length, 10) - 1;

    switch (event.key) {
      case 'ArrowDown':
        this.highlightedIndex =
          this.highlightedIndex < maxIndex ? this.highlightedIndex + 1 : 0;
        event.preventDefault();
        break;

      case 'ArrowUp':
        this.highlightedIndex =
          this.highlightedIndex > 0 ? this.highlightedIndex - 1 : maxIndex;
        event.preventDefault();
        break;

      case 'Enter':
        if (this.highlightedIndex >= 0) {
          const selected = this.paginatedArticles.artigos[this.highlightedIndex];
          this.redirectArticle(selected.resumo, selected.categoria);
          event.preventDefault();
        }
        break;
    }
  }
}
